import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Logo } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import { androidDownloadLink, iosDownloadLink } from 'shared/constants';
import { DownloadAppPlatform } from 'shared/types/download-app-platform';

import * as Styled from './download-app-banner.style';

const IMAGES_URL = '/images/download-banner';

type PlatformStore = {
  labelKey: string;
  url: string;
  badgeSrc: string;
};

const storeByPlatform: Record<DownloadAppPlatform, PlatformStore> = {
  [DownloadAppPlatform.Ios]: {
    labelKey: 'general.download-app-banner.store-label.ios',
    url: iosDownloadLink,
    badgeSrc: `${IMAGES_URL}/download-apple-app-store.svg`,
  },
  [DownloadAppPlatform.Android]: {
    labelKey: 'general.download-app-banner.store-label.android',
    url: androidDownloadLink,
    badgeSrc: `${IMAGES_URL}/download-google-play-store.svg`,
  },
};

export type DownloadAppBannerProps = {
  platform: DownloadAppPlatform;
};

export const DownloadAppBanner: React.FC<DownloadAppBannerProps> = ({
  platform,
}) => {
  const { t } = useTranslation();
  const { labelKey, url, badgeSrc } = storeByPlatform[platform];
  const imageUrl = `${IMAGES_URL}/${platform}-download-image`;

  return (
    <Styled.Container>
      <Styled.Content>
        <Styled.IconContainer>
          <Icon icon={Logo} />
        </Styled.IconContainer>

        <Styled.TitleContainer>
          <Typography variant="h3">
            {t('general.download-app-banner.title')}
          </Typography>

          <Typography variant="h1">
            {t('general.download-app-banner.description')}
          </Typography>
        </Styled.TitleContainer>

        <Styled.StoreLink href={url}>
          <Styled.StoreBadge src={badgeSrc} alt={t(labelKey)} />
        </Styled.StoreLink>
      </Styled.Content>

      <Styled.ImageContainer>
        <Styled.ImageLink href={url}>
          <Styled.Image
            src={`${imageUrl}.png`}
            srcSet={`${imageUrl}@2x.png 2x, ${imageUrl}@3x.png 3x`}
            alt=""
          />
        </Styled.ImageLink>
      </Styled.ImageContainer>
    </Styled.Container>
  );
};
